import { useSyncExternalStore } from 'react';

/**
 * 안내 투어가 <b>대신 펼쳐 두는</b> 사이드바 항목.
 *
 * "예전 주간회의는 업무 일정 안에 있습니다" 라고 말하면서 정작 접힌 그룹을 밝히면, 설명하는 것이
 * 화면에 없다. 투어 중에는 클릭이 막히므로(막이 삼킨다) 사용자가 직접 펼칠 수도 없다.
 *
 * 그래서 걸음이 자기 `expandMenuKeys` 를 여기 올려 두고, 사이드바가 그것을 <b>펼침 상태에 얹어</b> 읽는다.
 * 사용자가 접어 둔 상태(`openGroups`)는 건드리지 않는다 — 안내가 끝나면 원래대로 돌아와야 한다.
 *
 * 컴포넌트 밖의 작은 저장소인 이유: 투어는 {@code AppLayout} 이 띄우고 사이드바는 그 형제라,
 * 지금 걸음이 무엇인지를 프로퍼티로 내리려면 {@code AppLayout} 이 걸음 번호까지 쥐어야 한다.
 * 걸음 진행은 {@code TourOverlay} 의 일이고, 그 지식을 위로 끌어올릴 이유가 없다.
 */

let expandedKeys: readonly string[] = [];
const listeners = new Set<() => void>();

export function setTourExpandedKeys(next: readonly string[]): void {
  // 같은 값으로 알리면 사이드바가 매 걸음 헛되이 다시 그려진다.
  if (next.length === expandedKeys.length && next.every((key, i) => key === expandedKeys[i])) return;

  expandedKeys = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useTourExpandedKeys(): readonly string[] {
  return useSyncExternalStore(subscribe, () => expandedKeys, () => expandedKeys);
}
